export enum PaymentMethodType {
    CHECK = 'OfflineCheck',
    CASH = 'OfflineCash',
    BANK = 'PaymentBankAccount',
    CARD = 'CreditCard',
    CREDIT = 'AccountCredit',
}
